/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

export const EXTERNAL_INVESTMENT_CONSENT_TYPES = {
  CROSSOVER_PROSPECT: 'CROSSOVER_PROSPECT',
  CROSSOVER_EXISTING_II_OR_RAS: 'CROSSOVER_EXISTING_II_OR_RAS',
  CROSSOVER_EXISTING_II_OR_RAS_AND_RPS: 'CROSSOVER_EXISTING_II_OR_RAS_AND_RPS',
  II_OR_RAS_EXISTING: 'II_OR_RAS_EXISTING',
  II_OR_RAS_PROSPECT: 'II_OR_RAS_PROSPECT',
  NO_ACTION: 'NO_ACTION'
};

/*
Note these are not generic flags only pertains to yodlee/external accounts
 */
export const isPriorConsentedClient = (status) => {
  return [
    EXTERNAL_INVESTMENT_CONSENT_TYPES.II_OR_RAS_EXISTING,
    EXTERNAL_INVESTMENT_CONSENT_TYPES.CROSSOVER_EXISTING_II_OR_RAS,
    EXTERNAL_INVESTMENT_CONSENT_TYPES.CROSSOVER_EXISTING_II_OR_RAS_AND_RPS
  ].includes(status);
};

export const isProspectiveClient = (status) => {
  return [
    EXTERNAL_INVESTMENT_CONSENT_TYPES.II_OR_RAS_PROSPECT,
    EXTERNAL_INVESTMENT_CONSENT_TYPES.CROSSOVER_PROSPECT
  ].includes(status);
};

export const hasCompletedRegistrationTasks = (status) => {
  return [EXTERNAL_INVESTMENT_CONSENT_TYPES.NO_ACTION].includes(status);
};
